export default {
      id: "hourglass-usage",
      viewBox: "0 0 28 37",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#hourglass",
      toString: function () {
        return this.url;
      }
    }